var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "new-link-wrap" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "add-label-dialog",
          staticStyle: { "margin-top": "4vh" },
          attrs: {
            title: "新增链接",
            "append-to-body": "",
            visible: _vm.myVisible,
            "modal-append-to-body": false,
            width: "850px",
            height: "530px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.myVisible = $event
            }
          }
        },
        [
          _c("div", [
            _c("div", { staticClass: "row" }, [
              _c("span", { staticClass: "required" }, [_vm._v("*")]),
              _c("span", { staticClass: "label" }, [_vm._v("标题")]),
              _c(
                "div",
                [
                  _vm._t("value", function() {
                    return [
                      [
                        _c("el-input", {
                          staticStyle: { width: "310px" },
                          attrs: {
                            type: "text",
                            placeholder: "请输入链接标题",
                            maxlength: "30",
                            size: "small",
                            "show-word-limit": ""
                          },
                          model: {
                            value: _vm.form.title,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "title", $$v)
                            },
                            expression: "form.title"
                          }
                        })
                      ]
                    ]
                  })
                ],
                2
              )
            ]),
            _c("div", { staticClass: "row" }, [
              _c("span", { staticClass: "required" }, [_vm._v("*")]),
              _c("span", { staticClass: "label" }, [_vm._v("链接地址")]),
              _c(
                "div",
                [
                  _vm._t("value", function() {
                    return [
                      [
                        _c("el-input", {
                          staticStyle: { width: "310px" },
                          attrs: {
                            type: "text",
                            placeholder: "请输入以http或https开头的链接地址",
                            maxlength: 128,
                            size: "small",
                            "show-word-limit": ""
                          },
                          model: {
                            value: _vm.form.httpUrl,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "httpUrl", $$v)
                            },
                            expression: "form.httpUrl"
                          }
                        })
                      ]
                    ]
                  })
                ],
                2
              )
            ]),
            _vm.myType != 3
              ? _c("div", { staticClass: "row" }, [
                  _c(
                    "span",
                    {
                      staticClass: "required",
                      staticStyle: { color: "white" }
                    },
                    [_vm._v("*")]
                  ),
                  _c("span", { staticClass: "label" }, [_vm._v("使用场景")]),
                  _c(
                    "div",
                    [
                      _vm._t("value", function() {
                        return [
                          [
                            _c("el-input", {
                              ref: "myTextarea",
                              staticStyle: { width: "310px" },
                              attrs: {
                                type: "textarea",
                                id: "myTextarea",
                                clearable: "",
                                autocomplete: "off",
                                placeholder: "请输入副标题",
                                size: "small",
                                maxlength: 50,
                                "show-word-limit": ""
                              },
                              model: {
                                value: _vm.form.content,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "content", $$v)
                                },
                                expression: "form.content"
                              }
                            })
                          ]
                        ]
                      })
                    ],
                    2
                  )
                ])
              : _vm._e(),
            _c("div", { staticClass: "row" }, [
              _c("span", { staticClass: "required" }, [_vm._v("*")]),
              _c("span", { staticClass: "label" }, [_vm._v("缩略图")]),
              _c(
                "div",
                { staticClass: "value-wrap" },
                [
                  _vm._t("value", function() {
                    return [
                      [
                        _c(
                          "el-upload",
                          {
                            ref: "uploadLink",
                            staticClass: "avatar-uploader",
                            attrs: {
                              action: _vm.sendUrl,
                              accept: ".jpg,.jpeg,.png,.JPG,.JPEG,.PBG,",
                              headers: _vm.headers,
                              "show-file-list": false,
                              "on-error": _vm.onError,
                              "on-success": _vm.handleAvatarSuccess,
                              "before-upload": _vm.beforeAvatarUpload
                            }
                          },
                          [
                            !_vm.form.pictureUrl
                              ? _c("i", {
                                  staticClass:
                                    "el-icon-plus avatar-uploader-icon"
                                })
                              : _vm._e()
                          ]
                        ),
                        _vm.form.pictureUrl
                          ? _c("div", { staticClass: "avatar-wrap" }, [
                              _c("img", {
                                staticClass: "avatar",
                                attrs: { src: _vm.form.fileFullUrl }
                              }),
                              _c(
                                "div",
                                {
                                  staticClass: "close-wrap",
                                  on: {
                                    click: function($event) {
                                      return _vm.deletePhoto()
                                    }
                                  }
                                },
                                [
                                  _c("span", {
                                    staticClass: "el-icon-close close-icon"
                                  })
                                ]
                              )
                            ])
                          : _vm._e(),
                        _c("span", { staticClass: "tip" }, [
                          _vm._v("允许上传2M内的图片(jpg/png/jpeg)")
                        ])
                      ]
                    ]
                  })
                ],
                2
              )
            ])
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "20px" },
                  attrs: { size: "small " },
                  on: {
                    click: function($event) {
                      _vm.myVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    disabled: _vm.btnDisable
                  },
                  on: {
                    click: function($event) {
                      return _vm.confirmWeicome()
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }